import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

function GenreForm() {
  const [genreName, setGenreName] = useState("");
  const [loading, setLoading] = useState(false);
  const [originalGenre, setOriginalGenre] = useState("");

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      supabase
        .from("genres")
        .select("*")
        .eq("id", id)
        .single()
        .then(({ data }) => {
          // if (data) setGenreName(data.genres);
          if (data) {
            setGenreName(data.genres);
            setOriginalGenre(data.genres); // 👈 store original
          }

        });
    }
  }, [id]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (!genreName.trim()) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Please enter a genre name",
        timer: 3000,
        toast: true,
        showConfirmButton: false,
      });
      return;
    }

    setLoading(true);

    const normalized = genreName.trim().toLowerCase();

    const { data: existing } = await supabase
      .from("genres")
      .select("id")
      .ilike("genres", normalized);

    // ADD MODE
    if (!id) {
      if (existing && existing.length > 0) {
        setLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `"${genreName}" already exists`,
          timer: 3000,
          toast: true,
          showConfirmButton: false,
        });
        return;
      }
    }

    // EDIT MODE
    if (id) {
      const originalNormalized = originalGenre.trim().toLowerCase();

      // ✅ Only check duplicates IF name changed
      if (normalized !== originalNormalized) {
        const conflict = existing?.some(row => row.id !== id);

        if (conflict) {
          setLoading(false);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `"${genreName}" already exists`,
            timer: 3000,
            toast: true,
            showConfirmButton: false,
          });
          return;
        }
      }
    }

    if (id) {
      await supabase.from("genres").update({ genres: genreName.trim() }).eq("id", id);
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Genre updated successfully",
        timer: 3000,
        toast: true,
        showConfirmButton: false,
      });
    } else {
      await supabase.from("genres").insert([{ genres: genreName.trim() }]);
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Genre added successfully",
        timer: 3000,
        toast: true,
        showConfirmButton: false,
      });
    }

    navigate("/genres");
  };

  return (
    <div className="h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border p-8 rounded-md shadow-md"
        >
          <h1 className="text-3xl font-bold text-center">
            {id ? "Edit Genre" : "Add Genre"}
          </h1>

          <input
            type="text"
            value={genreName}
            onChange={(e) => setGenreName(e.target.value)}
            placeholder="Enter genre name"
            autoFocus
            className="w-full px-4 py-3 border rounded-md"
          />

          <div className="flex justify-center gap-4">
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>
            <Button variant="secondary" onClick={() => navigate("/genres")}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default GenreForm;
